module.exports = __webpack_public_path__ + "media/images/secured-by-opayo-logo-58d9cc352479bd6b8824592f39333925.jpg";